import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { useMutation } from '@apollo/client';
import { VOID_TRANSACTION } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';

const ModalVoidConfirm = ({
  isOpen,
  setIsOpen,
  transactionId,
  cardNumber,
  amount,
  voidType,
  voidDetails,
  setVoidDetails,
  setBill,
}) => {

    const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
    const [failedIsOpen, setFailedIsOpen] = useState(false)
    
    const [voidTransaction, {loading}] = useMutation(VOID_TRANSACTION, {
      onCompleted: (data) => {
        setBill(prevBill => ({
          ...prevBill,
          transactions: [...prevBill.transactions, data.voidTransaction]
        }))
        setSuccessfullyIsOpen(true)
        setFailedIsOpen(false)
        setIsOpen(false)
      },
      onError: (error) => {
        setFailedIsOpen(true)
        setIsOpen(false)
      }
    })

  const handleVoid = () => {
    if(loading) return
    voidTransaction({
      variables: {
        input: {
          transactionId,
          reason: voidDetails
        },
      },
    });
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>
            {
              voidType==='REFUND'? 
              `Are you sure you want to void $${Number(amount).toFixed(2)} to the card ending in ${cardNumber?.slice(-4)}. Note that this action will result in the refund being cancelled, the original purchase will still be applied to the card.`
              :
              `Are you sure you want to void $${Number(amount).toFixed(2)} to the card ending in ${cardNumber?.slice(-4)}. Note that this will immediately and irrevocably cancel the customers payment.` }
          </div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `} 
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleVoid}
              data-loading={loading}
              additionalstyle={`
                width: 68px;
              `}
            >
              {loading? null: 'Void'}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        amount={amount}
        cardNumber={cardNumber}
        setDetails={setVoidDetails}
        type='void'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        amount={amount}
        cardNumber={cardNumber}
        loading={loading}
        retryFunction={handleVoid}
        type='void'
      />
    </>
  );
}

export default ModalVoidConfirm;
